
export default [
  {
    name: "btrip",
    path: "/btrip",
    component: (resolve) => require(['./btripLayout.vue'], resolve),
    children:[
      {
        name:'register',
        path:'/btrip/outgoing/register',
        component: (resolve) => require(['./components/outgoingRegister.vue'], resolve)
    },
    {
      name:'List',
      path:'/btrip/outgoing/list',
      component: (resolve) => require(['./components/outgoingList.vue'], resolve)
    },
    {
      name:'Application-form',
      path:'/btrip/outgoing/Applicationform',
      component: (resolve) => require (['./components/BusinessTripApplicationSheet.vue'], resolve)
    },
    {
      name:'Correct',
      path:'/btrip/outgoing/Correct',
      component: (resolve) => require (['./components/outgoingRegisterCorrect.vue'], resolve)
    }
  ]
  },
];



// WEBPACK FOOTER //
// ./src/views/btrip/router.js